import React from "react";

//UI Material
import { Button, TableCell, TableRow, Typography } from "@mui/material";

//Material Icons
import { ArrowForwardIos } from "@mui/icons-material";

export default function EntryRow({ entryData }) {
  return (
    <TableRow>
      <TableCell align="center" sx={{ maxWidth: "200px" }}>
        <Typography variant="body2">{entryData.id}</Typography>
      </TableCell>
      <TableCell align="center" sx={{ maxWidth: "200px" }}>
        <Typography variant="body2">{entryData.itemId}</Typography>
      </TableCell>
      <TableCell align="center" sx={{ maxWidth: "200px" }}>
        <Typography variant="body2">{entryData.name || ""}</Typography>
      </TableCell>
      <TableCell align="center" sx={{ maxWidth: "200px" }}>
        <Typography variant="body2">
          {new Date(entryData.createdAt).toLocaleString()}
        </Typography>
      </TableCell>
      <TableCell align="center" sx={{ maxWidth: "200px" }}>
        <Typography variant="body2">{Number(entryData.quantity).toFixed(2)}</Typography>
      </TableCell>
      <TableCell align="center" sx={{ maxWidth: "200px" }}>
        <Typography variant="body2">{`${entryData.supplier} (${entryData.supplierId})`}</Typography>
      </TableCell>
      <TableCell align="center" sx={{ maxWidth: "200px" }}>
        <Button
          size="small"
          color="secondary"
          variant="contained"
          sx={{ color: "white" }}
          endIcon={<ArrowForwardIos />}
          onClick={() => {
            window.location.href = `/entry?id=${entryData.id}`;
          }}
        >
          Ver detalles
        </Button>
      </TableCell>
    </TableRow>
  );
}
